module.exports = __webpack_public_path__ + "bronze-medal-0c55d71190e9aff715061d9f266859da.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/bronze-medal.png
// module id = OywE
// module chunks = client